export const getColorByName = (name: string): string => {
  const colors: { [key: string]: string } = {
    A: "rgb(239 68 68 / var(--tw-bg-opacity))", // Red
    B: "rgb(234 88 12 / var(--tw-bg-opacity))", // Orange
    C: "rgb(245 158 11 / var(--tw-bg-opacity))", // Yellow
    D: "rgb(132 204 22 / var(--tw-bg-opacity))", // Lime
    E: "rgb(34 197 94 / var(--tw-bg-opacity))", // Green
    F: "rgb(14 165 233 / var(--tw-bg-opacity))", // Sky
    G: "rgb(99 102 241 / var(--tw-bg-opacity))", // Indigo
    H: "rgb(139 92 246 / var(--tw-bg-opacity))", // Violet
    I: "rgb(168 85 247 / var(--tw-bg-opacity))", // Purple
    J: "rgb(236 72 153 / var(--tw-bg-opacity))", // Pink
    K: "rgb(244 63 94 / var(--tw-bg-opacity))", // Rose
    L: "rgb(251 191 36 / var(--tw-bg-opacity))", // Amber
    M: "rgb(52 211 153 / var(--tw-bg-opacity))", // Teal
    N: "rgb(6 182 212 / var(--tw-bg-opacity))", // Cyan
    O: "rgb(59 130 246 / var(--tw-bg-opacity))", // Blue
    P: "rgb(147 51 234 / var(--tw-bg-opacity))", // Fuchsia
    Q: "rgb(202 138 4 / var(--tw-bg-opacity))", // Mustard
    R: "rgb(253 164 175 / var(--tw-bg-opacity))", // Soft pink
    S: "rgb(251 113 133 / var(--tw-bg-opacity))", // Rose-red
    T: "rgb(125 211 252 / var(--tw-bg-opacity))", // Light blue
    U: "rgb(165 180 252 / var(--tw-bg-opacity))", // Light indigo
    V: "rgb(187 247 208 / var(--tw-bg-opacity))", // Light green
    W: "rgb(253 230 138 / var(--tw-bg-opacity))", // Pale yellow
    X: "rgb(254 202 202 / var(--tw-bg-opacity))", // Light rose
    Y: "rgb(221 214 254 / var(--tw-bg-opacity))", // Lavender
    Z: "rgb(186 230 253 / var(--tw-bg-opacity))", // Light sky
  };

  const firstLetter = name?.charAt(0)?.toUpperCase();
  return colors[firstLetter] || "rgb(229 231 235 / var(--tw-bg-opacity))"; // fallback: gray-200
};
